import { TypographyType, TextareaType, CellType } from "data/CellComponent";
import { Stack } from "@mui/joy";
import type { ProgramContentType } from "data/BlockComponent";
import React, { memo } from "react";
import type { TaskContentV2ViewerMode } from "../TaskContentV2";
import CellV2 from "../cell/CellV2";

function LineV2({
  lineStr,
  lineIndex,
  taskKey,
  setData,
  blockIndex,
  isLastLine,
  readonly,
  viewerMode = "auto",
  hasDivider,
  onAttemptEdit,
}: {
  lineStr: string;
  lineIndex: number;
  taskKey: string;
  setData: React.Dispatch<
    React.SetStateAction<ProgramContentType[] | undefined>
  >;
  blockIndex: number;
  isLastLine: boolean;
  readonly: boolean;
  viewerMode?: TaskContentV2ViewerMode;
  hasDivider?: boolean;
  onAttemptEdit?: () => void;
}) {
  const line: CellType[] = JSON.parse(lineStr);

  return (
    <div
      key={`${taskKey}_${blockIndex}_${lineIndex}`}
      className="flex gap-[10px] items-stretch w-full"
    >
      {line.map((cell, cellIndex) => (
        <Stack
          key={
            (cell.content as TextareaType)?.editorKey
              ? `${taskKey}_textarea_${
                  (cell.content as TextareaType).editorKey
                }`
              : `${taskKey}_${blockIndex}_${lineIndex}_${cellIndex}`
          }
          sx={{
            width: `${((cell.content as TypographyType)?.width || 1) * 100}%`,
            alignSelf: "stretch",
            mb: !isLastLine
              ? cell.type === "typography" &&
                (cell.content as TypographyType).isLabel
                ? "4px"
                : cell.type === "divider"
                  ? 0
                  : "12px"
              : 0,
            ...(hasDivider && {
              pb: "12px",
              borderBottomWidth: "1px",
              borderColor: "divider",
            }),
          }}
          className="flex justify-center"
        >
          <CellV2
            type={cell.type}
            contentStr={JSON.stringify(cell.content)}
            blockIndex={blockIndex}
            lineIndex={lineIndex}
            cellIndex={cellIndex}
            setData={setData}
            readonly={readonly}
            viewerMode={viewerMode}
            onAttemptEdit={onAttemptEdit}
          />
        </Stack>
      ))}
    </div>
  );
}

export default memo(LineV2);
